import React from 'react'
import BooksList from '../books/BooksList'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { useTranslation } from 'react-i18next'

type Props = {}

const AudioBooksList: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation()
    return (
        <BooksList
            category_label={t("หนังสือเสียง")}
            category_path={routeName.e_library.audio_book}
            category_pathname_label={routeName.e_library.audio_book_list}
            library_category_name={ELibraryCategory.AUDIO_BOOK}
            path_detail={routeName.e_library.audio_book_detail}
            allow_shadow={true}
            allow_view_audio={true}
        />
    )
}

export default AudioBooksList